import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { RecentGradesState } from '../models/store-viewmodel';
import { Grade } from '../models/grades-viewmodel';
import { root } from '@/shared/store/index';
import { Config } from '../models/config-viewmodel';

Vue.use(Vuex);

const state: RecentGradesState = {
    grades: [],
    loading: true,
    config: {
        language: '',
        apiBasePath: '',
        userId: '',
        overviewUrl: '',
        labels: {}
    }
}

const mutations: MutationTree<RecentGradesState> = {
    setGrades(state, grades: Grade[]) {
        state.grades = grades;
    },

    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    }
}

const actions: ActionTree<RecentGradesState, RecentGradesState> = {
    setGrades(context, grades: Grade[]) {
        context.commit('setGrades', grades);
    },

    setConfig(context, config: Config) {
        context.commit('setConfig', config);
        },

    setLoading(context, payload: boolean) {
        context.commit('setLoading', payload);
    }
}

const getters: GetterTree<RecentGradesState, RecentGradesState> = {
    config(state) {
        return state.config;
    },

    loading(state) {
        return state.loading;
    },

    grades(state) {
        return state.grades;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})
